import { Component } from '@angular/core';

@Component({
  selector: 'blob',
  imports: [],
  templateUrl: './blob.component.html',
  styleUrl: './blob.component.scss'
})
export class BlobComponent {

}
